<template>
  <div v-if="$store.getters.getDealer && !$store.getters.getDealer.gcs_status.confirmed" class="animated fadeIn col-md-12 col-sm-12">

    <b-alert v-if="$store.getters.getDealer.has_distributor" variant="warning" show>
      <div>{{$t('It is not possible to place new orders. Contact your distributor for more information.')}}</div>
    </b-alert>

    <b-alert v-else variant="warning" show>
      <span v-html="$t('Completa l’attivazione del tuo account, ')"></span>
      <router-link :to="{ name: 'Gcs' }">{{$t('click here')}}</router-link>
      <div>{{$t('ATTENTION: failure to complete this procedure implies limitations in purchasing updates.')}}</div>
    </b-alert>
  </div>
</template>

<script>

export default {
    name: "GcsWarning",
    components: {},
    data () {
        return {
            languages: [],
            is_gcs: true,
            email: '',
            gcs: {
              confirmed_at: null,
              data: {},
            }
        }
    },
  }
</script>
